import homepage from './homepage'
import accountSwitch from './accountSwitch'
import dropOutApply from './dropOutApply'
import thesis from './thesis'
import notice from './notice'

const studentUnion = {
  path: 'studentUnion',
  component: resolve => require(['../../../components/pages/studentUnion'], resolve),
  redirect: 'studentUnion/homepage',
  children: [homepage, accountSwitch, notice, dropOutApply, ...thesis]
}

export default studentUnion
